import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';

@Injectable()
export class StockService extends ApiService {
  constructor(private http: Http) {
    super('api/stocks/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/stock.service.ts